import { ref, readonly, Ref } from 'vue';

const debugMode = ref(false);

const username = ref<string | undefined>();
const usernameSet = ref(false);

const selectedInputDeviceId: Ref<string | null> = ref(null);
const selectedOutputDeviceId: Ref<string | null> = ref(null);
const audioSettingsSet = ref(false);

function setUsername(value: string) {
  if (value === null || value === undefined || value.length === 0) {
    console.error('Username cannot be null or undefined or empty');
    return;
  }

  localStorage.setItem('username', value);
  username.value = value;
  usernameSet.value = true;
}

function resetAudioSettings() {
  audioSettingsSet.value = false;
  selectedInputDeviceId.value = null;
  selectedOutputDeviceId.value = null;
}

export function useState() {
  return {
    username: readonly(username),
    usernameSet: readonly(usernameSet),
    setUsername,
    debugMode,
    selectedInputDeviceId,
    selectedOutputDeviceId,
    audioSettingsSet,
    resetAudioSettings,
  };
}
